/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type IrrApiVersionEnum = 'v2' | 'v9';

export const IrrApiVersionEnum = {

    V2: 'v2' as IrrApiVersionEnum,

    V9: 'v9' as IrrApiVersionEnum
};

